import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import './ProfessionalProfilePage.css';

const ProfessionalProfilePage = () => {
  const [isBookmarked, setIsBookmarked] = useState(false);

  const professionalData = {
    avatar: 'https://api.builder.io/api/v1/image/assets/TEMP/848d07b91856af19f3110e8d9dbfb236bec2b554?width=176',
    title: 'Architecture Engineer',
    name: 'Engr. Jerome Bell',
    location: 'United Kingdom',
    projectCount: 50,
    membershipType: 'Global',
    isVerified: true,
    rating: '4.5',
    category: 'Building Materials',
    expertise: 'Office Architecture, Home Architect',
    interestedLocations: 'USA, Canada, Sadia Arab, Dubai, Katar, Bangladesh, India',
    experience: '12 years',
    coverImage: 'https://api.builder.io/api/v1/image/assets/TEMP/b93e1ce7b82724d8f6137167ac3cbbb8a6ea3b58?width=1798',
  };

  const projects = Array(24).fill(null).map((_, index) => ({
    id: index + 1,
    type: 'Renovation',
    title: 'Revitalization of The Relic Site of Yongle Palace / URBANUS',
    image: index % 2 === 0 
      ? 'https://api.builder.io/api/v1/image/assets/TEMP/bdf28fac139b7aefbdcafb52da7f3cb6265a669a?width=875'
      : 'https://api.builder.io/api/v1/image/assets/TEMP/3708ed12cbb400ecbf7049427bf73efc1f5c6cd3?width=875',
  }));

  return (
    <div className="professional-profile-page">
      <Header />
      
      <main className="professional-profile-content">
        {/* Breadcrumb */}
        <div className="breadcrumb">
          <Link to="/" className="breadcrumb-link">Home</Link>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M6 13L10 9L6 5" stroke="#505050" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <Link to="/specialists" className="breadcrumb-link">Professional</Link>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M6 13L10 9L6 5" stroke="#505050" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span className="breadcrumb-current">Professional Profile</span>
        </div>

        <div className="profile-wrapper">
          {/* Profile Header Section */}
          <div className="profile-header-section">
            <div className="profile-info-container">
              {/* Avatar and Project Count */}
              <div className="profile-top-row">
                <div className="profile-avatar">
                  <img 
                    src={professionalData.avatar} 
                    alt={professionalData.name}
                    className="avatar-image"
                  />
                </div>
                <div className="project-count">
                  <span className="count-number">{professionalData.projectCount}</span>
                  <span className="count-label">Project</span>
                </div>
              </div>

              {/* Professional Title and Details */}
              <div className="profile-details">
                <h1 className="profile-title">{professionalData.title}</h1>
                <div className="profile-name-location">
                  <span className="profile-name">{professionalData.name}</span>
                  <span className="separator"> | </span>
                  <span className="profile-location">{professionalData.location}</span>
                </div>

                {/* Badges Row */}
                <div className="profile-badges">
                  <div className="badge-group">
                    <div className="membership-badge">
                      <img 
                        src="https://api.builder.io/api/v1/image/assets/TEMP/050559d54da8d35ba6d11841efdb737d4c3ae660?width=44" 
                        alt="Platinum" 
                        className="membership-icon"
                      />
                      <span className="membership-text">{professionalData.membershipType}</span>
                    </div>
                    {professionalData.isVerified && (
                      <div className="verified-badge">
                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M22 11C22 11.9323 20.7329 12.6871 20.5034 13.5472C20.2653 14.4377 20.9782 15.7221 20.528 16.5015C20.0705 17.2923 18.597 17.314 17.9562 17.9562C17.314 18.5984 17.2923 20.0705 16.5014 20.528C15.7221 20.9782 14.4377 20.2653 13.5472 20.5034C12.6871 20.7329 11.9337 22 11 22C10.0663 22 9.31291 20.7329 8.45276 20.5034C7.56231 20.2653 6.27788 20.9782 5.49856 20.528C4.70769 20.0705 4.68605 18.597 4.04382 17.9562C3.4016 17.3154 1.92954 17.2923 1.47205 16.5015C1.02177 15.7221 1.73472 14.4377 1.49659 13.5472C1.26712 12.6871 0 11.9338 0 11C0 10.0663 1.26712 9.31292 1.49659 8.45278C1.73472 7.56233 1.02177 6.27789 1.47205 5.49857C1.92954 4.7077 3.40305 4.68605 4.04382 4.04383C4.68605 3.40161 4.70769 1.92955 5.49856 1.47206C6.27788 1.02178 7.56231 1.73472 8.45276 1.49659C9.31291 1.26712 10.0663 0 11 0C11.9337 0 12.6871 1.26712 13.5472 1.49659C14.4377 1.73472 15.7221 1.02178 16.5014 1.47206C17.2923 1.92955 17.314 3.40305 17.9562 4.04383C18.5984 4.68461 20.0705 4.7077 20.528 5.49857C20.9782 6.27789 20.2653 7.56233 20.5034 8.45278C20.7329 9.31292 22 10.0663 22 11Z" fill="#29ABE2"/>
                          <path d="M16.5876 7.6017C16.1229 7.137 15.3696 7.137 14.9049 7.6017L10.0312 12.4754L8.00786 10.452C7.54315 9.9873 6.7898 9.9873 6.32509 10.452C5.86039 10.9167 5.86039 11.6701 6.32509 12.1348L9.14798 14.9577C9.39188 15.2016 9.71372 15.317 10.0327 15.3055C10.3516 15.317 10.6734 15.2016 10.9173 14.9577L16.5891 9.28591C17.0538 8.8212 17.0538 8.06786 16.5891 7.60315L16.5876 7.6017Z" fill="white"/>
                        </svg>
                        <span className="verified-text">Verified</span>
                      </div>
                    )}
                  </div>
                  <div className="rating-badge">
                    <span className="rating-value">{professionalData.rating}</span>
                    <span className="rating-label">Reviews</span>
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="profile-actions">
                <button className="btn-primary">View Mobile</button>
                <button className="btn-secondary">Chat</button>
              </div>

              {/* Professional Info */}
              <div className="professional-info">
                <div className="info-item">
                  <span className="info-label">Category:</span>
                  <span className="info-value">{professionalData.category}</span>
                </div>
                <div className="info-item">
                  <span className="info-label">Expertise:</span>
                  <span className="info-value">{professionalData.expertise}</span>
                </div>
                <div className="info-item">
                  <span className="info-label">Interested location:</span>
                  <span className="info-value">{professionalData.interestedLocations}</span>
                </div>
                <div className="info-item">
                  <span className="info-label">Experience:</span>
                  <span className="info-value">{professionalData.experience}</span>
                </div>
              </div>

              {/* Tab Navigation */}
              <div className="profile-tabs">
                <button className="tab-item active">
                  All Project ({professionalData.projectCount})
                </button>
              </div>
            </div>

            {/* Cover Image */}
            <div className="cover-image-container">
              <img 
                src={professionalData.coverImage} 
                alt="Cover" 
                className="cover-image"
              />
              <button 
                className="bookmark-btn"
                onClick={() => setIsBookmarked(!isBookmarked)}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path 
                    d="M17 3H6.5C6.10218 3 5.72064 3.15804 5.43934 3.43934C5.15804 3.72064 5 4.10218 5 4.5V21C5.00007 21.1338 5.03595 21.2652 5.10393 21.3805C5.17191 21.4958 5.2695 21.5908 5.38659 21.6557C5.50367 21.7206 5.63598 21.7529 5.76978 21.7494C5.90358 21.7458 6.034 21.7066 6.1475 21.6356L11.75 18.1341L17.3534 21.6356C17.4669 21.7063 17.5972 21.7454 17.7309 21.7488C17.8646 21.7522 17.9967 21.7198 18.1136 21.655C18.2306 21.5902 18.3281 21.4953 18.396 21.3801C18.4639 21.2649 18.4998 21.1337 18.5 21V4.5C18.5 4.10218 18.342 3.72064 18.0607 3.43934C17.7794 3.15804 17.3978 3 17 3ZM17 19.6472L12.1466 16.6144C12.0274 16.5399 11.8896 16.5004 11.7491 16.5004C11.6085 16.5004 11.4708 16.5399 11.3516 16.6144L6.5 19.6472V4.5H17V19.6472Z" 
                    fill={isBookmarked ? "#1F396C" : "#969696"}
                  />
                </svg>
              </button>
            </div>
          </div>

          {/* Projects Grid Section */}
          <div className="projects-section">
            <div className="projects-grid">
              {projects.map((project) => (
                <Link to={`/project/${project.id}`} key={project.id} className="project-card">
                  <div className="project-image-wrapper">
                    <img 
                      src={project.image} 
                      alt={project.title}
                      className="project-image"
                    />
                  </div>
                  <div className="project-info">
                    <h3 className="project-type">{project.type}</h3>
                    <p className="project-title">{project.title}</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default ProfessionalProfilePage;
